export enum ApprovedStatus {
  UnApproved = 0,
  Approved = 1,
  Pending = 2,
  Rejected = 3,
  UnAccepted = 4,
}

export enum ChangeRequestStatus {
  Pending = 'pending',
  Accepted = 'accepted',
  Rejected = 'rejected',
}

export enum SurveyStatus {
  Active = 0,
  Close = 1,
}

export enum ShareBirthdayStatus {
  No = 1,
  Yes = 0,
}

export enum AllowAdvertisementStatus {
  No = 1,
  Yes = 0,
}

export enum BannerStatus {
  Active = 0,
  Inactive = 1,
}

export enum OnlineStatus {
  Online = 1,
  Offline = 0,
}

export enum DeletedStatus {
  Deleted = 1,
  NotDeleted = 0,
}
